import Enhancer from '../enhancer.js';
import EnhancerApp from '../enhancer-app.js';

export default class ProgressButton extends Enhancer {

    states = {
        default: 'default',
        progress: 'progress'
    };

    init() {

        if (!this.getData('state')) {
            this.state = this.states.default;
        }

        this.setState();

        this.element.addEventListener('click', this.handleClick.bind(this));
        this.element.addEventListener('reset', this.reset.bind(this));

        if (!this.element.getAttribute('aria-live')) {
            this.element.setAttribute('aria-live', 'polite');
        }
    }

    handleClick() {

        if (this.state === this.states.progress) {
            return;
        }

        this.state = this.states.progress;

        this.setState();

    }

    setState() {
        if (this.state === this.states.default) {
            this.reset();
        }
        else {
            this.progress();
        }
    }

    progress() {
        this.state = this.states.progress;

        this.defaultElement.style.display = 'none';
        this.progressElement.style.display = 'inline';

        if (this.disable) {
            this.element.disabled = true;
        }

        this.setClassNames();

        this.element.setAttribute('role', 'status');

        this.setClassNames();

        // Workaround for IE11
        // For some reason IE11 has problems with CustomEvents triggering. Propbably
        // a problem with Babel and IE11
        //const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        //if (isIE11) {
        //    setTimeout(() => {
        //        this.reset();
        //    }, 1000)
        //}
    }

    reset() {

        this.state = this.states.default;

        this.defaultElement.style.display = 'inline';
        this.progressElement.style.display = 'none';

        this.setClassNames();

        this.element.disabled = false;

        this.element.removeAttribute('role');
    }

    setClassNames() {
        const defaultClassName = this.defaultClassName;
        const progressClassName = this.progressClassName;

        if (this.state === this.states.default) {
            if (defaultClassName) {
                this.element.classList.add(defaultClassName);
            }
            if (progressClassName) {
                this.element.classList.remove(progressClassName);
            }
        }
        else {
            if (defaultClassName) {
                this.element.classList.remove(defaultClassName);
            }
            if (progressClassName) {
                this.element.classList.add(progressClassName);
            }
        }
    }

    get state() {
        return this.getData('state');
    }

    set state(value) {
        return this.setData('state', value);
    }

    get disable() {
        return Boolean(this.getData('disable'));
    }

    set disable(value) {
        return this.setData('disable', value);
    }

    get defaultElement() {
        return this.get('.state-default');
    }

    get progressElement() {
        return this.get('.state-progress');
    }

    get progressClassName() {
        return this.getData('progress-class-name');
    }

    get defaultClassName() {
        return this.getData('default-class-name');
    }
}

EnhancerApp.register('ProgressButton', ProgressButton);